import { api } from '../../../lib/api'

export const GET_STATISTICS_BY_PRODUCT_REQUEST = 'GET_STATISTICS_BY_PRODUCT_REQUEST'
export const GET_STATISTICS_BY_PRODUCT_SUCCESS = 'GET_STATISTICS_BY_PRODUCT_SUCCESS'
export const GET_STATISTICS_BY_PRODUCT_FAILED = 'GET_STATISTICS_BY_PRODUCT_FAILED'

export const getStatisticsByProduct = function (productId) {
  return function (dispatch) {
    dispatch({
      type: GET_STATISTICS_BY_PRODUCT_REQUEST
    })
    api.getStatisticsByProduct(productId).then(getStatisticsByProductResponse => {
      dispatch({
        type: GET_STATISTICS_BY_PRODUCT_SUCCESS,
        payload: getStatisticsByProductResponse
      })
    }).catch(error => {
      dispatch({
        type: GET_STATISTICS_BY_PRODUCT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/statistics/get-product-statistics.js